import * as THREE from 'three';
import type { Tickable } from '../engine/Game';

export class Clouds implements Tickable {
  readonly group = new THREE.Group();
  private clouds: THREE.Mesh[] = [];
  private speeds: number[] = [];

  constructor() {
    const mat = new THREE.MeshBasicMaterial({
      color: '#ffffff',
      transparent: true,
      opacity: 0.85,
      depthWrite: false,
    });
    for (let i = 0; i < 28; i++) {
      const cluster = new THREE.Group();
      const puffs = 3 + Math.floor(Math.random() * 3);
      for (let j = 0; j < puffs; j++) {
        const s = 2 + Math.random() * 3;
        const puff = new THREE.Mesh(new THREE.SphereGeometry(s, 10, 8), mat);
        puff.position.set(
          (Math.random() - 0.5) * 6,
          (Math.random() - 0.5) * 1.5,
          (Math.random() - 0.5) * 4,
        );
        cluster.add(puff);
      }
      cluster.position.set(
        (Math.random() - 0.5) * 220,
        28 + Math.random() * 12,
        (Math.random() - 0.5) * 220,
      );
      this.group.add(cluster);
      this.clouds.push(cluster as unknown as THREE.Mesh);
      this.speeds.push(0.4 + Math.random() * 0.6);
    }
  }

  tick(dt: number): void {
    for (let i = 0; i < this.clouds.length; i++) {
      const c = this.clouds[i];
      c.position.x += this.speeds[i] * dt;
      if (c.position.x > 120) c.position.x = -120;
    }
  }
}
